import styled from 'styled-components';
import EmptyStateBackgroundImage from './emptyState.png';

import {
  textSmallNormal,
  textSmallSemiBold,
  textTinySemiBold,
} from '../../../Typography';

export const Container = styled.div`
  background: var(--black-300);
  border: 1px solid var(--black-500);
  border-radius: 8px;
  color: var(--text-standard-primary);
  height: 217px;

  a {
    color: unset;
    text-decoration: unset;
    &:hover {
      text-decoration: underline;
    }
  }

  .tabs {
    display: flex;
    gap: 24px;
    margin-bottom: 20px;
    border-bottom: 1px solid var(--black-300);
    padding-bottom: 12px;
  }

  .seeAll {
    margin-left: auto;
    align-self: center;
    ${textTinySemiBold};
    color: var(--text-primary);
  }

  div[role='tablist'] {
    display: flex;
    padding: var(--space-150) var(--space-200);
    gap: var(--space-150);
    border-bottom: 1px solid var(--black-500);

    &:before {
      display: none;
    }
  }

  button[role='tab'] {
    border: none;
    padding: var(--space-75);
    border-radius: 4px;
    color: var(--text-standard-secondary);
    ${textSmallSemiBold};

    &[aria-selected='true'] {
      color: var(--text-standard-primary);
      background: var(--black-500);
    }
  }

  .mantine-Tabs-root {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .table.loadingContainer tbody {
    tr:nth-child(even),
    tr:nth-child(odd) {
      background: none;
    }

    div {
      margin: var(--space-100) 0;
    }
  }

  .table {
    border-collapse: collapse;
    margin: var(--space-100) var(--space-100);
    width: calc(100% - var(--space-200));

    th,
    td {
      text-align: left;
      ${textSmallNormal};
      box-sizing: border-box;

      .ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      div {
        margin: var(--space-150);
      }

      &:not(:first-child) > div {
        margin-left: 0;
      }
    }

    th {
      color: var(--text-standard-secondary);
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    tbody tr {
      td {
        transition: background 0.2s;

        &:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }

        &:last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }

      &:nth-child(even) td {
        background: var(--black-200);
      }

      &:hover td {
        background: var(--black-500);
      }
    }
  }

  .service {
    a {
      position: relative;
      top: -1px;
      margin: 0 var(--space-100);
    }
  }

  .entity {
    width: 100%;
    max-width: 20vw;
  }

  .invocations {
    text-wrap: nowrap;
    color: var(--text-subtle);
  }

  .table .duration {
    text-wrap: nowrap;
    color: var(--text-standard-secondary);
  }

  .trend {
    div {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    svg {
      width: 12px;
      height: 12px;
    }

    &.up {
      color: var(--text-warning);
      path {
        stroke: var(--text-warning);
      }
    }

    &.down {
      color: var(--text-success);
      path {
        color: var(--text-success);
      }
    }
  }

  .noData {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    flex: 1;
    color: var(--text-standard-secondary);
    ${textSmallSemiBold};

    background-image: url(${EmptyStateBackgroundImage});
    background-repeat: no-repeat;
    background-position: right center;

    p {
      text-wrap: balance;
      text-align: center;
      max-width: 500px;
      margin: 0;
    }
  }
`;
